'use strict';

var _ = require('lodash');
var angular = require('angular');
var toastr = require('toastr');
var StrategyCustomController = function StrategyCustomController($scope, elementService, saveStrategyService, strategiesService, strategyConstants, momentService, validation, featureToggleService, conditionsAndActionsService, statementBoxService, commonUiConstants, xtFormValidationService) {
  var NEW_STRATEGY = 'New Custom Strategy';
  var NEW_ALERT_STRATEGY = 'New Custom Alert Strategy';
  var OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = '';
  function determinePanelTitle() {
    if ($scope.strategy.old) {
      return $scope.strategy.name;
    }
    return $scope.strategy.type === strategyConstants.PANEL_TYPE.ALERTS ? NEW_ALERT_STRATEGY : NEW_STRATEGY;
  }
  $scope.elementService = elementService;
  $scope.summaryMessage = strategyConstants.ERROR_MESSAGES.MULTIPLE;
  $scope.panelTitle = determinePanelTitle();
  $scope.dialogMessageType = null;
  $scope.STRATEGY_NAME_PATTERN = commonUiConstants.ALPHA_NUMERIC_WITH_SOME_EXTRA_CHARS;
  $scope.strategyNameMsg = 'Strategy name contains invalid characters. Only alphanumeric characters and -, _, <, >, = are allowed.';
  function createFirstGroup() {
    if (!$scope.strategy.groups || !$scope.strategy.groups.length) {
      $scope.strategy.groups = [elementService.createGroup()];
    }
  }
  createFirstGroup();
  function fetchStrategyFormulae() {
    var fieldArr = [];
    var fieldPrefix = 'custom';
    var formulaNameList = [];
    _.forEach($scope.strategy.groups, function (group) {
      _.forEach(group.conditions, function (condition) {
        if (condition.field.split('.')[0] === fieldPrefix) {
          fieldArr.push(condition.field.split('.')[1]);
        }
      });
    });
    var formulae = [];
    _.forEach($scope.conditionCategories, function (category) {
      _.filter(category, function () {
        _.forEach(category.criteria, function (criteria) {
          if (criteria.field.split('.')[0] === fieldPrefix && formulaNameList.indexOf(criteria.field.split('.')[1]) == -1) {
            var formula = {};
            formula.name = criteria.field.split('.')[1];
            formula.formula = criteria.formula;
            if (fieldArr.indexOf(formula.name) != -1) {
              formulaNameList.push(criteria.field.split('.')[1]);
              formulae.push(formula);
            }
          }
        });
      });
    });
    return formulae;
  }
  function resetFlowTypeDependentGroups() {
    _.forEach($scope.strategy.groups, function (group) {
      if (isLevelFlowTypeDependent(group.level)) {
        group.conditions = [elementService.createCondition()];
        group.actions = [elementService.createAction()];
      }
    });
  }
  function showFlowTypeConfirmation() {
    $scope.dialogMessageType = strategyConstants.CONFIRMATION_MESSAGES.FLOW_TYPE.STRATEGY;
    angular.element('#flow-type-custom-confirm-modal').modal('show');
  }
  function setDefaultFlowType() {
    $scope.strategy.flowType = $scope.strategy.flowType || strategyConstants.DefaultFlowType["default"];
  }
  $scope.switchFlowType = function () {
    resetFlowTypeDependentGroups();
    var selectedGroup = elementService.getSelectedGroup();
    $scope.$emit('strategy-custom:flowTypeChanged', selectedGroup.level, $scope.strategy.flowType);
  };
  $scope.cancelFlowTypeChange = function () {
    $scope.strategy.flowType = _.find(strategyConstants.FlowType, function (val) {
      return val !== $scope.strategy.flowType;
    });
  };
  function handleFlowTypeChange(newType, oldType) {
    if (oldType !== undefined && newType !== oldType) {
      if (hasFilledFlowTypeDependentGroup()) {
        showFlowTypeConfirmation();
      } else {
        $scope.switchFlowType();
      }
    } else if (oldType === undefined && newType !== oldType) {
      $scope.switchFlowType();
    }
  }
  function handleGroupLevelChange(event, domain) {
    if (isLevelFlowTypeDependent(domain)) {
      setDefaultFlowType();
    }
  }
  if (featureToggleService.isEnabled('MAPPED_MODE')) {
    $scope.$watch('strategy.flowType', handleFlowTypeChange);
    $scope.$on('strategy-custom:selectedLevelChanged', handleGroupLevelChange);
  }
  $scope.resetIfEmpty = function () {
    if (isCustomStrategy()) {
      createFirstGroup();
    }
  };
  function isCustomStrategy() {
    return $scope.strategy.basis === strategyConstants.StrategyType.CUSTOM;
  }
  function isCollectionStateDefault(collection) {
    return collection.length === 1 && collection[0].isEmpty();
  }
  function add(newElement, collectionName) {
    var selectedRowType = elementService.getSelectedRowType();
    var selectedGroup = elementService.getSelectedGroup();
    var collection = selectedGroup[collectionName];
    if (selectedRowType === collectionName) {
      var selectedElement = elementService.getSelectedElement();
      var insertionIndex = collection.indexOf(selectedElement);
      if (insertionIndex !== -1) {
        if (selectedElement.isEmpty()) {
          collection[insertionIndex] = newElement;
        } else {
          collection.splice(insertionIndex + 1, 0, newElement);
        }
      } else {
        if (isCollectionStateDefault(collection)) {
          collection[0] = newElement;
        } else {
          collection.push(newElement);
        }
      }
    } else {
      if (isCollectionStateDefault(collection)) {
        collection[0] = newElement;
      } else {
        collection.push(newElement);
      }
    }
    elementService.selectRow(selectedGroup, newElement, collection, selectedRowType);
  }
  $scope.conditionsAccordionSelect = function (conditionCategory, conditionCriteria) {
    var newConditionParams = {
      quantifier: 'AND',
      category: conditionCategory.categoryName,
      criterion: conditionCriteria.criteriaName,
      field: conditionCriteria.field,
      operator: conditionCriteria.operators[0].operator,
      precision: conditionCriteria.operators[0].precision,
      isFieldValueRequired: !_.isUndefined(conditionCategory.isFieldValueRequired) ? conditionCategory.isFieldValueRequired : true
    };
    var newCondition = elementService.createCondition(newConditionParams);
    add(newCondition, 'conditions');
  };
  $scope.actionsAccordionSelect = function (actionCategory, action) {
    var newActionParam = {
      category: actionCategory.categoryName,
      criterion: action.criteriaName,
      action: action.actions[0].option,
      argsNo: action.actions[0].argsNo,
      field: action.field,
      criteriaType: action.criteriaType ? action.criteriaType.fieldValue : null
    };
    var newAction = elementService.createAction(newActionParam);
    add(newAction, 'actions');
  };
  $scope.isGroupHighlighted = function (group) {
    return elementService.isGroupSelected(group);
  };
  $scope.isRowSelected = function () {
    return elementService.isRowSelected();
  };
  $scope.isGroupSelected = function (group) {
    return $scope.isGroupHighlighted(group) && !$scope.isRowSelected();
  };
  $scope.selectStrategyGroup = function (strategyGroup) {
    elementService.selectGroup(strategyGroup, $scope.strategy.groups);
    $scope.$emit('strategy-custom:selectedLevelChanged', strategyGroup.level, $scope.strategy.flowType);
  };
  function clearModalElements() {
    angular.element('#edit-custom-confirm-modal').modal();
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  }
  function closeAction() {
    clearModalElements();
    elementService.clearSelection();
    $scope.hideSummary();
    $scope.xtForm.reset();
    $scope.closePanelHandler();
    $scope.$emit('strategies:toggleReadOnlyPanelVisibility');
  }
  function resetFlowTypeIfNotApplicable(strategyToSave) {
    strategyToSave.strategy.flowType = hasFlowTypeDependentGroup() ? strategyToSave.strategy.flowType : undefined;
  }
  $scope.strategySaveConfirm = function (newName) {
    var strategyToSave = {
      strategy: _.extend({}, $scope.strategy)
    };
    var createdAt = momentService.now(momentService.FIELD.CREATED_AT);
    if (newName) {
      strategyToSave.strategy.name = newName;
      strategyToSave.strategy.createdAt = createdAt;
      strategyToSave.strategy.createdDate = momentService.copy(createdAt, momentService.FIELD.CREATED_DATE);
      strategyToSave.strategy.technicalId = undefined;
      strategyToSave.strategy.usage = 0;
    }
    resetFlowTypeIfNotApplicable(strategyToSave);
    strategyToSave.strategy = strategiesService.cleanStrategy(strategyToSave.strategy);
    strategyToSave.strategy.formulae = fetchStrategyFormulae();
    saveStrategyService.saveStrategy(strategyToSave.strategy).then(function (response) {
      $scope.$emit('strategy:dataAndSelectionChanged', {
        name: strategyToSave.strategy.name,
        technicalId: response.technicalId
      });
      closeAction();
      $scope.saveStrategyHandler(strategyToSave);
      toastr.success('Successfully saved changes.');
    }, function (reason) {
      $scope.isSummaryVisible = true;
      var reasonStr = reason.data ? ' (' + reason.data.message + ')' : '';
      $scope.summaryMessage = strategyConstants.ERROR_MESSAGES.SAVING + reasonStr;
      strategiesService.repopulateStrategy($scope.strategy);
    });
  };
  function isLevelFlowTypeDependent(domain) {
    var level = conditionsAndActionsService.getLevelByDomain(domain);
    return level.isFlowTypeSelectable;
  }
  function hasFlowTypeDependentGroup() {
    return _.find($scope.strategy.groups, function (group) {
      return isLevelFlowTypeDependent(group.level);
    });
  }
  function isCriteriaCollectionEmpty(criteria) {
    return _.every(criteria, validation.isCriteriaEmpty);
  }
  function isGroupFilled(group) {
    return !isCriteriaCollectionEmpty(group.conditions) || !isCriteriaCollectionEmpty(group.actions);
  }
  function hasFilledFlowTypeDependentGroup() {
    return _.find($scope.strategy.groups, function (group) {
      return isLevelFlowTypeDependent(group.level) && isGroupFilled(group);
    });
  }
  function hasGroupWithAllActionsEmpty() {
    return _.find($scope.strategy.groups, function (group) {
      return isCriteriaCollectionEmpty(group.actions);
    });
  }
  function hasIncompleteConditions() {
    return _.find($scope.strategy.groups, function (group) {
      return _.find(group.conditions, validation.isCriteriaIncomplete);
    });
  }
  function hasIncompleteActions() {
    return _.find($scope.strategy.groups, function (group) {
      return _.find(group.actions, validation.isCriteriaIncomplete);
    });
  }
  function hasOperandDataQuantityOverThreshold() {
    var criteriaOverThreshold = [];
    _.forEach($scope.strategy.groups, function (group) {
      criteriaOverThreshold = criteriaOverThreshold.concat(validation.filterCriteriaOverThreshold(group.conditions));
    });
    if (criteriaOverThreshold.length > 0) {
      var criteriaNames = validation.getCriteriaNamesForMessage(criteriaOverThreshold);
      OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = strategyConstants.ERROR_MESSAGES.OPERAND_DATA_OVER_THRESHOLD + criteriaNames;
      return true;
    }
    return false;
  }
  function prepareSummaryMessage(errorType) {
    $scope.isSummaryVisible = true;
    $scope.summaryMessage = errorType;
  }
  $scope.focusError = function () {
    if ($scope.focusErrorMsg) {
      $scope.focusErrorMsg();
    }
  };
  $scope.saveButtonHandler = function () {
    $scope.xtForm.submit();
    var duplicated;
    if (hasGroupWithAllActionsEmpty()) {
      prepareSummaryMessage(strategyConstants.ERROR_MESSAGES.MISSING_ACTIONS);
      return $scope.focusError();
    } else if (hasIncompleteConditions()) {
      prepareSummaryMessage(strategyConstants.ERROR_MESSAGES.INCOMPLETE_CONDITIONS);
      return $scope.focusError();
    } else if (hasIncompleteActions()) {
      prepareSummaryMessage(strategyConstants.ERROR_MESSAGES.INCOMPLETE_ACTIONS);
      return $scope.focusError();
    } else if (hasOperandDataQuantityOverThreshold()) {
      prepareSummaryMessage(OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE);
      return $scope.focusError();
    } else if ((duplicated = validation.collectDuplicatedConditions($scope.strategy.commonConditions)) && duplicated.length) {
      return prepareSummaryMessage(strategyConstants.ERROR_MESSAGES.STRATEGY_DUPLICATES + duplicated.join(', '));
    }
    if ($scope.xtForm.form.$invalid && $scope.xtForm.form.$error && !_.isEmpty($scope.xtForm.form.$error)) {
      $scope.isSummaryVisible = true;
      $scope.summaryMessage = xtFormValidationService.getSummaryMessage($scope.xtForm.form.$error);
      $scope.focusError();
      return;
    }
    var oldObj = _.extend({}, $scope.strategy.old);
    var newObj = _.extend({}, $scope.strategy);
    newObj.old = undefined;
    oldObj.old = undefined;
    if (!_.isEqual(oldObj, newObj) && $scope.strategy.usage > 0) {
      angular.element('#edit-custom-confirm-modal').modal();
    } else {
      $scope.strategySaveConfirm();
    }
  };
  $scope.cancelButtonHandler = function () {
    closeAction();
  };
  $scope.isSummaryVisible = false;
  $scope.hideSummary = function () {
    $scope.isSummaryVisible = false;
  };
  $scope.isStatementEmpty = function (group) {
    var tempStrategy = _.cloneDeep($scope.strategy);
    if (group) {
      tempStrategy.groups = [group];
    }
    return statementBoxService.isStatementEmpty(null, tempStrategy);
  };
  $scope.isStatementBoxVisible = function (group) {
    return group.isVisible && !$scope.isStatementEmpty(group);
  };
  $scope.toggleStatementBox = function (strategyGroup) {
    if (!$scope.isStatementEmpty($scope.strategyGroup)) {
      strategyGroup.isVisible = !strategyGroup.isVisible;
    } else {
      strategyGroup.isVisible = false;
    }
  };
};
StrategyCustomController.$inject = ['$scope', 'StrategyElementService', 'SaveStrategyService', 'StrategiesService', 'StrategyConstants', 'MomentService', 'CriteriaValidateAndFilterService', 'FeatureToggleService', 'ConditionsAndActionsService', 'StatementBoxService', 'CommonUiConstants', 'XtFormValidationService'];
module.exports = StrategyCustomController;